import SecureLS from "secure-ls";

export default {
    appLS: function() {
        return new SecureLS({
            encodingType: "rc4",
            isCompression: false,
            encryptionSecret: "Y3vrn5#!917"
        });
    }
};